import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { KhenThuongAPI } from '../../services/feature-api';
import { Icon, fmtNgay } from './khen-thuong-shared';

// Thẻ chúc mừng Du lịch 2026 — hiện NGAY sau khi đăng ký (du-lich-2026-form) và xem lại ở /khenthuong/du-lich-2026/chuc-mung
// để đại lý chụp màn hình đi khoe. Lời gửi gắm = 1 câu random từ loai_khen_thuong.loi_gui_gam (admin sửa, {ten} = users.facebook).

const VANG = 'linear-gradient(100deg,#a8751b 0%,#f7e3a1 18%,#fffaf0 28%,#d9aa3f 42%,#a8751b 55%,#f7e3a1 75%,#fff4cf 85%,#a8751b 100%)';
const VANG_HONG = 'linear-gradient(100deg,#b76e79 0%,#f9d5c9 18%,#fff5f0 28%,#e7a99a 42%,#b76e79 55%,#f9d5c9 75%,#fff0ea 85%,#b76e79 100%)';

// Mở thẻ = màu ngẫu nhiên (anh Bình chốt 02/10/2026); nút "Đổi màu" nhảy ngẫu nhiên sang màu khác.
const CHU_DE = [
  { ten: 'Hồng ngọc', nen: ['#c81e1e', '#6e0d0d', '#220404'], kim: VANG, dam: '#f5c96a' },
  { ten: 'Lục bảo', nen: ['#0f8a5f', '#064e3b', '#01140f'], kim: VANG, dam: '#f5c96a' },
  { ten: 'Hoàng gia', nen: ['#8b2fd6', '#3b0764', '#12031f'], kim: VANG, dam: '#f5c96a' },
  { ten: 'Đêm sao', nen: ['#2451d6', '#0b1f4d', '#020617'], kim: VANG, dam: '#f5c96a' },
  { ten: 'Vàng hồng', nen: ['#db2777', '#831843', '#2a0616'], kim: VANG_HONG, dam: '#f9cbbd' },
  { ten: 'Đại dương', nen: ['#0891b2', '#0e4f5c', '#03161b'], kim: VANG, dam: '#f5c96a' },
  { ten: 'Huyền kim', nen: ['#52525b', '#18181b', '#000000'], kim: VANG, dam: '#f5c96a' },
  { ten: 'Đỏ tươi', nen: ['#ff3131', '#c8101e', '#4a0409'], kim: VANG, dam: '#ffd978' },
  { ten: 'Xanh bơ', nen: ['#9cbf3b', '#4f7a1c', '#172608'], kim: VANG, dam: '#f7e08a' },
];

const CSS = `
.cm-serif{font-family:'Playfair Display',Georgia,serif}
.cm-kim{background:var(--kim);background-size:200% auto;-webkit-background-clip:text;background-clip:text;color:transparent;animation:cm-anh 5s linear infinite}
.cm-vien{background:var(--kim);background-size:200% auto;animation:cm-anh 6s linear infinite}
@keyframes cm-anh{to{background-position:-200% center}}
@keyframes cm-xoay{to{transform:rotate(360deg)}}
@keyframes cm-lap-lanh{0%,100%{opacity:.15;transform:scale(.6)}50%{opacity:1;transform:scale(1.15)}}
@keyframes cm-roi{0%{transform:translateY(-10vh) rotate(0);opacity:1}100%{transform:translateY(110vh) rotate(720deg);opacity:0}}
@keyframes cm-hien{from{opacity:0;transform:translateY(24px) scale(.96)}to{opacity:1;transform:none}}
@keyframes cm-dap{0%,100%{box-shadow:0 0 22px 2px var(--glow)}50%{box-shadow:0 0 44px 10px var(--glow)}}
.cm-hien{animation:cm-hien .9s cubic-bezier(.2,.8,.2,1) both}
.cm-sang{filter:drop-shadow(0 0 14px var(--glow))}
`;

// Vị trí sao / hoa giấy tính 1 lần (không nhảy khi đổi màu)
const gia = (i, k) => ((Math.sin(i * 12.9898 + k * 78.233) * 43758.5453) % 1 + 1) % 1;
const SAO = Array.from({ length: 18 }, (_, i) => ({ top: `${gia(i, 1) * 100}%`, left: `${gia(i, 2) * 100}%`, size: 8 + gia(i, 3) * 14, delay: `${gia(i, 4) * 3}s`, dur: `${2 + gia(i, 5) * 2.5}s` }));
const HOA_GIAY = Array.from({ length: 28 }, (_, i) => ({ left: `${gia(i, 6) * 100}%`, w: 6 + gia(i, 7) * 6, delay: `${gia(i, 8) * 1.2}s`, dur: `${2.6 + gia(i, 9) * 2}s`, mau: ['#f7e3a1', '#ffffff', '#d9aa3f', '#fca5a5', '#fde68a'][i % 5] }));

// bo = câu đang hiện → bấm "Đổi lời chúc" luôn ra câu khác
export const chonCau = (loiGuiGam, bo = '') => {
  const ds = String(loiGuiGam || '').split('\n').map((s) => s.trim()).filter(Boolean);
  const con = ds.length > 1 ? ds.filter((c) => c !== bo) : ds;
  return con.length ? con[Math.floor(Math.random() * con.length)] : '';
};

const hexRgba = (hex, a) => {
  const n = parseInt(hex.slice(1), 16);
  return `rgba(${(n >> 16) & 255},${(n >> 8) & 255},${n & 255},${a})`;
};

export const TheChucMung = ({ user, hoSo, loiGuiGam }) => {
  const navigate = useNavigate();
  const [iMau, setIMau] = useState(() => Math.floor(Math.random() * CHU_DE.length));
  const [cau, setCau] = useState(() => chonCau(loiGuiGam));
  const t = CHU_DE[iMau];
  const ten = user?.facebook || user?.name || '';

  const doiMau = () => {
    let j = iMau;
    while (j === iMau) j = Math.floor(Math.random() * CHU_DE.length);
    setIMau(j);
  };

  return (
    <div className="min-h-screen relative text-white"
         style={{ '--kim': t.kim, '--glow': hexRgba(t.dam, 0.55), background: `radial-gradient(130% 85% at 50% 0%, ${t.nen[0]} 0%, ${t.nen[1]} 45%, ${t.nen[2]} 100%)`, transition: 'background .6s' }}>
      <style>{CSS}</style>

      {/* Lớp trang trí fixed + overflow-hidden riêng: nằm trong khung có nút thì bấm nút sẽ kéo trượt ngang cả trang */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none">
        <div className="absolute left-1/2 top-[18%] w-[160vmax] h-[160vmax] -translate-x-1/2 -translate-y-1/2 pointer-events-none opacity-25"
             style={{ background: `repeating-conic-gradient(from 0deg, ${hexRgba(t.dam, 0.5)} 0deg 6deg, transparent 6deg 18deg)`, animation: 'cm-xoay 80s linear infinite', maskImage: 'radial-gradient(circle, #000 0%, transparent 45%)', WebkitMaskImage: 'radial-gradient(circle, #000 0%, transparent 45%)' }} />
        {SAO.map((s, i) => (
          <span key={i} className="absolute pointer-events-none" style={{ top: s.top, left: s.left, fontSize: s.size, color: t.dam, animation: `cm-lap-lanh ${s.dur} ease-in-out ${s.delay} infinite` }}>✦</span>
        ))}
        {HOA_GIAY.map((h, i) => (
          <span key={`h${i}`} className="absolute top-0 pointer-events-none rounded-[2px]"
                style={{ left: h.left, width: h.w, height: h.w * 1.6, background: h.mau, animation: `cm-roi ${h.dur} ease-in ${h.delay} both` }} />
        ))}
      </div>

      <div className="relative z-10 max-w-[420px] mx-auto px-4 pt-3 pb-8">
        <div className="flex items-center gap-2 mb-3">
          <button type="button" onClick={() => navigate('/khenthuong')} aria-label="Quay lại"
                  className="w-9 h-9 rounded-full bg-white/10 border border-white/20 backdrop-blur flex items-center justify-center active:scale-95">
            <Icon name="arrow_back" size={18} />
          </button>
          <span className="flex-1" />
          {cau && (
            <button type="button" onClick={() => setCau(chonCau(loiGuiGam, cau))}
                    className="flex items-center gap-1 px-3 py-1.5 rounded-full bg-white/10 border border-white/25 backdrop-blur text-[12px] font-bold active:scale-95">
              <Icon name="autorenew" size={16} />Đổi lời chúc
            </button>)}
          <button type="button" onClick={doiMau}
                  className="flex items-center gap-1.5 pl-1.5 pr-3 py-1.5 rounded-full bg-white/10 border border-white/25 backdrop-blur text-[12px] font-bold active:scale-95">
            <span className="w-5 h-5 rounded-full border border-white/60" style={{ background: `conic-gradient(${CHU_DE.map((c) => c.nen[0]).join(',')},${CHU_DE[0].nen[0]})` }} />
            Đổi màu
          </button>
        </div>

        {/* Thẻ — vùng để chụp màn hình: gọn 1 màn hình điện thoại 390×844 */}
        <div className="cm-hien cm-vien rounded-[30px] p-[2px]" style={{ boxShadow: `0 0 50px -6px ${hexRgba(t.dam, 0.6)}` }}>
          <div className="rounded-[28px] px-4 pt-4 pb-4 text-center relative overflow-hidden backdrop-blur-md"
               style={{ background: `radial-gradient(120% 60% at 50% 0%, ${hexRgba(t.nen[0], 0.9)} 0%, ${hexRgba(t.nen[1], 0.9)} 55%, ${hexRgba(t.nen[2], 0.95)} 100%)` }}>
            <p className="text-[10.5px] font-bold tracking-[0.26em] uppercase whitespace-nowrap" style={{ color: t.dam }}>✈ Yody Phương Anh · Du lịch 2026</p>
            <h1 className="cm-serif cm-kim cm-sang italic font-black text-[54px] leading-[1.1] pb-1 px-2 whitespace-nowrap">Chúc mừng</h1>
            <span className="inline-block cm-vien rounded-full px-3 py-1 text-[11.5px] font-black tracking-[0.06em] uppercase whitespace-nowrap text-[#3b2604] shadow-lg">
              Đã ghi danh chương trình Du lịch 2026
            </span>

            {/* Ảnh đại diện trong vòng vàng xoay */}
            <div className="relative mx-auto mt-4 w-[118px] h-[118px]">
              <div className="absolute inset-0 rounded-full" style={{ background: `conic-gradient(from 0deg, ${t.dam}, #fffaf0, ${t.dam}, transparent, ${t.dam})`, animation: 'cm-xoay 6s linear infinite' }} />
              <div className="absolute inset-[4px] rounded-full overflow-hidden" style={{ background: t.nen[2], animation: 'cm-dap 3s ease-in-out infinite' }}>
                {user?.avatar
                  ? <img src={user.avatar} alt="" className="w-full h-full object-cover" />
                  : <div className="w-full h-full flex items-center justify-center cm-serif cm-kim text-[54px] font-black">{(ten || '?').trim().charAt(0).toUpperCase()}</div>}
              </div>
              <div className="absolute -bottom-1 left-1/2 -translate-x-1/2 w-9 h-9 rounded-full cm-vien flex items-center justify-center shadow-lg">
                <Icon name="workspace_premium" size={22} className="text-[#5a3a05]" />
              </div>
            </div>

            <p className="cm-serif cm-kim cm-sang font-black text-[36px] leading-tight mt-2 break-words">{ten}</p>
            <p className="text-[11px] font-bold tracking-[0.18em]" style={{ color: t.dam }}>
              MÃ {user?.code} · {hoSo?.maDangKy} · {fmtNgay(String(hoSo?.createdAt || '').slice(0, 10))}
            </p>

            {/* Lời cam kết của đại lý */}
            <p className="mt-3 text-[11px] font-bold tracking-[0.28em] uppercase text-white/75">Tôi cam kết chinh phục</p>
            <p className="text-[40px] font-black leading-none mt-1 tabular-nums" style={{ textShadow: `0 0 26px ${hexRgba(t.dam, 0.8)}` }}>{(Number(hoSo?.dsCamKet) || 0).toLocaleString('vi-VN')}</p>
            <p className="text-[12px] text-white/75 mt-1">Doanh Số Năm 2026</p>

            {cau && (
              <div key={cau} className="cm-hien mt-4 rounded-2xl px-4 pt-6 pb-3 relative text-left"
                   style={{ background: `linear-gradient(160deg, ${hexRgba(t.dam, 0.24)} 0%, rgba(255,255,255,0.05) 70%)`, border: `1.5px solid ${hexRgba(t.dam, 0.6)}`, boxShadow: `inset 0 0 30px ${hexRgba(t.dam, 0.15)}` }}>
                <span className="cm-serif cm-kim absolute -top-3 left-3 text-[64px] leading-none font-black">“</span>
                <p className="cm-serif italic font-bold text-[20px] leading-snug text-white" style={{ textShadow: '0 1px 8px rgba(0,0,0,.35)' }}>
                  {cau.split('{ten}').map((doan, i) => (
                    <React.Fragment key={i}>
                      {i > 0 && <span className="cm-kim cm-sang not-italic font-black text-[22px]">{ten}</span>}
                      {doan}
                    </React.Fragment>
                  ))}
                </p>
                <p className="mt-2 text-right text-[10.5px] font-bold tracking-[0.2em] uppercase" style={{ color: t.dam }}>— Ban lãnh đạo Yody Phương Anh</p>
              </div>)}
          </div>
        </div>

        <p className="mt-4 text-center text-[12px] text-white/80">📸 Chụp màn hình để khoe ngay · bấm <b>Đổi lời chúc</b>, <b>Đổi màu</b> để chọn kiểu mình thích</p>
        <button type="button" onClick={() => navigate('/khenthuong/du-lich-2026/tinh-trang')}
                className="mt-3 w-full rounded-xl py-3 text-[14px] font-black text-[#3b2604] cm-vien shadow-lg active:scale-[0.99]">
          Theo dõi tình trạng và kết quả
        </button>
        <button type="button" onClick={() => navigate('/khenthuong')}
                className="mt-2 w-full rounded-xl border border-white/40 py-2.5 text-[13px] font-bold bg-white/5">
          Về danh sách khen thưởng
        </button>
      </div>
    </div>
  );
};

// /khenthuong/du-lich-2026/chuc-mung — xem lại thẻ sau khi đã đăng ký
const TheChucMungPage = ({ accessToken }) => {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!accessToken) return;
    KhenThuongAPI.getCuaToi(accessToken).then((r) => (r.success ? setData(r.data) : setError(r.error || 'Không tải được hồ sơ')));
  }, [accessToken]);

  if (data?.hoSo) return <TheChucMung user={data.user} hoSo={data.hoSo} loiGuiGam={data.chienDich?.loiGuiGam} />;
  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6 text-center text-white" style={{ background: 'radial-gradient(130% 85% at 50% 0%, #c81e1e, #6e0d0d 45%, #220404)' }}>
      {!data && !error && <p className="text-white/70 text-sm">Đang tải...</p>}
      {error && <p className="text-red-200 text-sm">{error}</p>}
      {data && !data.hoSo && (<>
        <p className="text-[16px] font-black">Bạn chưa đăng ký Du lịch 2026</p>
        <button type="button" onClick={() => navigate('/khenthuong/du-lich-2026/dang-ky')} className="mt-4 rounded-xl bg-white text-red-700 px-6 py-3 font-black">
          Đăng ký + cam kết doanh số
        </button>
      </>)}
    </div>
  );
};

export default TheChucMungPage;
